export enum UserPermission {
    'user' = 'user',
    'admin' = 'admin'
}
